import { Check, ChevronRight, Ban } from 'lucide-react'
import { useStages } from '@/features/admin/stages/hooks'

export function StageStepperHeader({ configurationCode, currentStageCode }: {
  configurationCode: string
  currentStageCode: string
}) {
  const stagesQ = useStages(configurationCode)
  const all = stagesQ.data ?? []
  // Stages list comes from product config; isTerminal stages render as separate "end" badges
  // (Anulowana / Zrealizowana) rather than steps in the linear flow.
  const linear = all.filter(s => !s.isTerminal)
  const terminals = all.filter(s => s.isTerminal)
  const idx = linear.findIndex(s => s.code === currentStageCode)
  const currentTerminal = terminals.find(s => s.code === currentStageCode) ?? null
  const isOnTerminal = currentTerminal !== null

  return (
    <div className="flex items-center gap-1.5 px-6 py-3 border-b border-slate-200 bg-white overflow-x-auto">
      {linear.map((s, i) => {
        const isCurrent = !isOnTerminal && i === idx
        const isPast = !isOnTerminal && idx >= 0 && i < idx
        const isFuture = !isCurrent && !isPast && !isOnTerminal
        return (
          <div key={s.code} className="flex items-center gap-1.5 whitespace-nowrap">
            <span
              title={s.code}
              className={[
                'inline-flex items-center gap-1.5 rounded-md text-xs font-medium transition-colors',
                isCurrent && 'bg-emerald-600 text-white px-3 py-1.5 shadow-sm ring-2 ring-emerald-100',
                isPast && 'bg-sky-50 text-sky-700 px-2.5 py-1 border border-sky-200',
                (isFuture || isOnTerminal) && 'bg-white text-slate-500 px-2.5 py-1 border border-slate-200',
              ].filter(Boolean).join(' ')}
            >
              <span className={[
                'inline-flex items-center justify-center text-[10px] font-semibold rounded-full size-4',
                isCurrent && 'bg-white/20 text-white',
                isPast && 'bg-sky-100 text-sky-700',
                (isFuture || isOnTerminal) && 'bg-slate-100 text-slate-500',
              ].filter(Boolean).join(' ')}>
                {isPast ? <Check size={10} strokeWidth={3} /> : i + 1}
              </span>
              {s.labelPl}
            </span>
            {i < linear.length - 1 && (
              <ChevronRight className="size-3.5 text-slate-300 shrink-0" />
            )}
          </div>
        )
      })}
      {currentTerminal && (
        <>
          <ChevronRight className="size-3.5 text-slate-300 shrink-0 ml-1" />
          <span
            title={currentTerminal.code}
            className="inline-flex items-center gap-1.5 rounded-md bg-rose-600 text-white px-3 py-1.5 text-xs font-semibold shadow-sm ring-2 ring-rose-100 whitespace-nowrap"
          >
            <Ban size={12} strokeWidth={2.5} />
            {currentTerminal.labelPl}
          </span>
        </>
      )}
    </div>
  )
}
